const STAGGER_MS = 120;

function initReveal() {
  const targets = document.querySelectorAll('.reveal, .reveal-image');

  if (!targets.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    targets.forEach((element) => {
      element.classList.add(element.classList.contains('reveal-image') ? 'reveal-image--visible' : 'reveal--visible');
    });
    return;
  }

  const groups = new Map();

  targets.forEach((element) => {
    // [data-reveal-group] lets a page scope its own independent stagger sequence
    // smaller than a full Shopify section — e.g. the catalogue page's five category
    // sections each need their own 0..N sequence, not one continuous count across
    // all of them just because they share one .shopify-section wrapper.
    const group = element.closest('[data-reveal-group]') || element.closest('.shopify-section') || element.parentElement;
    if (!groups.has(group)) groups.set(group, []);
    groups.get(group).push(element);
  });

  groups.forEach((elements, group) => {
    // A group element can override the default 120ms stagger via data-reveal-stagger="100".
    const customStagger = group instanceof Element ? Number.parseInt(group.dataset.revealStagger, 10) : NaN;
    const stagger = Number.isFinite(customStagger) ? customStagger : STAGGER_MS;

    elements.forEach((element, index) => {
      element.style.setProperty('--reveal-delay', `${index * stagger}ms`);
    });
  });

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add(
          entry.target.classList.contains('reveal-image') ? 'reveal-image--visible' : 'reveal--visible'
        );
        obs.unobserve(entry.target);
      });
    },
    { root: null, rootMargin: '0px 0px -15% 0px', threshold: 0 }
  );

  // Defer observation by a frame so the browser paints the hidden (opacity: 0) state at
  // least once first. Without this, elements already inside the trigger zone at page load
  // (e.g. a section starting right at the bottom of a 100svh hero) get revealed on the very
  // first observer callback, before the hidden state was ever visibly painted — the fade
  // plays out during initial load and reads as "no animation" even though it technically ran.
  requestAnimationFrame(() => {
    targets.forEach((element) => observer.observe(element));
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initReveal);
} else {
  initReveal();
}
